import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, getCsrfToken } from "../apiClient";


const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/api`,
  credentials: "include",
  prepareHeaders: async (headers) => {
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");

    const csrfToken = await getCsrfToken();
    if (csrfToken) {
      headers.set("x-csrf-token", csrfToken);
    }
    return headers;
  },
});

export const customBaseQuery = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (
    result.error &&
    result.error.status === 403 &&
    (result.error.data?.message === "invalid csrf token" ||
      result.error.data?.code === "EBADCSRFTOKEN" ||
      result.error.data?.errorMessage === "invalid csrf token")
  ) {
    await getCsrfToken(true);
    result = await baseQuery(args, api, extraOptions);
  }

  return result;
};
